import { reject, isNull } from 'lodash/fp';
import guestQuantityLimit from '../guestQuantityLimit';

export default (guestInfo, list) =>
  reject(
    ({ limitRules = null }) =>
      !isNull(limitRules) && guestQuantityLimit(guestInfo, limitRules) === 0,
    list
  );
